import { render, staticRenderFns } from "./OnlyFreeAreaLayout.vue?vue&type=template&id=3bb00884&"
import script from "./OnlyFreeAreaLayout.vue?vue&type=script&lang=ts&"
export * from "./OnlyFreeAreaLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports